var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 592,
    viewBox: "0 0 492 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M491.138 387.803C491.138 601.744 317.705 775.177 103.764 775.177C-110.176 775.177 -283.609 601.744 -283.609 387.803C-283.609 173.863 -110.176 0.429688 103.764 0.429688C317.705 0.429688 491.138 173.863 491.138 387.803ZM-173.7 387.803C-173.7 541.043 -49.4747 665.267 103.764 665.267C257.004 665.267 381.228 541.043 381.228 387.803C381.228 234.564 257.004 110.34 103.764 110.34C-49.4747 110.34 -173.7 234.564 -173.7 387.803Z",
    fill: "#1B9B48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M368.148 675.615C368.148 821.631 249.779 940 103.764 940C-42.252 940 -160.621 821.631 -160.621 675.615C-160.621 529.6 -42.252 411.23 103.764 411.23C249.779 411.23 368.148 529.6 368.148 675.615ZM-110.016 675.615C-110.016 793.682 -14.3034 889.394 103.764 889.394C221.831 889.394 317.543 793.682 317.543 675.615C317.543 557.548 221.831 461.836 103.764 461.836C-14.3034 461.836 -110.016 557.548 -110.016 675.615Z",
    fill: "#1B9B48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackRound);
export default __webpack_public_path__ + "static/media/backRound.297bb85f066dd5bad1627135c029a10e.svg";
export { ForwardRef as ReactComponent };